import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { RevealText, Reveal } from "@/components/Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/content";

export default function Faq() {
  return (
    <div className="pt-8 md:pt-12">
      <section className="mx-auto max-w-[1400px] px-6 md:px-10">
        <p className="overline text-sage mb-6">Good to know</p>
        <RevealText
          as="h1"
          className="font-serif font-light text-ink leading-[0.95] tracking-tight text-5xl sm:text-6xl md:text-7xl"
          lines={["Questions,", "answered"]}
        />
      </section>

      <section className="mx-auto max-w-3xl px-6 md:px-10 mt-16 pb-24">
        <Reveal>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-ink/10">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-serif font-light text-2xl md:text-3xl text-ink hover:no-underline hover:text-sage py-7"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-inksoft text-base leading-relaxed pb-7 max-w-2xl">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </section>

      <section className="bg-stone2 py-24 md:py-32">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <h2 className="font-serif font-light text-ink text-4xl md:text-6xl leading-tight max-w-xl">
            Still have a question?
          </h2>
          <Link
            to="/contact"
            data-testid="faq-contact-link"
            className="group inline-flex items-center gap-3 rounded-full bg-ink text-cream px-9 py-4 text-sm font-medium hover:bg-sagedark transition-colors"
          >
            Get in touch
            <ArrowUpRight size={17} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>
      </section>
    </div>
  );
}
